// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1dnY4","label":"Radio_label__11uBv","checkMark":"Radio_checkMark__sf00D","disabled":"Radio_disabled__2P6WL"};